import { Header } from './Header.';
import Footer from './Footer';
import "./Styles/favoris.css";
import EmptyCardGIF from "../Images/empty-cart.gif"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageHeader from './PageHeader';
import { addProductInCart, getFavourites, isProductInCart, setFavourites } from '../Services/localStorage';
import { useState } from 'react';
import { useEffect } from 'react';
import { priceFr } from '../Services/Numbers';

export const Favoris = () => {
    const [favs, setFavs] = useState([]) 
    const productsURL = process.env.REACT_APP_API_BASE_URL+'/images/products/';
    
    document.title = "Favoris - KabaaShop"

    useEffect(()=>{
        setFavs(getFavourites())
    }, true)

    const deleteFromFav = (id) => {
        let tmpFav = favs

        tmpFav.splice(tmpFav.findIndex((obj) => obj.id === id), 1);

        setFavs(setFavourites(tmpFav))
    }

    const addToCart = (event, product) => {
        product.thumb = product.image
        addProductInCart(product, 1)
        event.target.remove()
    }

    return (
        <>
        <ToastContainer />
            <Header />
            <PageHeader title={'Favoris'} />

            {
                favs.length > 0 ?
                    favs.map((f) => {
                        return (
                            <div className='favoris-container'>
                
                                <div className='favoris-item'>
                                    <div className="favoris-item-image">
                                        <img src={productsURL+f.image} alt={f.slug}/>
                                    </div>
                                    <div className="favoris-item-desc">
                                        <a href={"/boutique/"+f.slug}>{f.name} </a>
                                        <h3>{priceFr(f.priceToPay)} F</h3>
                                    </div>
                                    <div className="favoris-item-actions">
                                        {
                                            isProductInCart(f.id) ?
                                            '' :
                                            <button onClick={(e)=>{addToCart(e,f)}} className='favoris-addToCart'>Au Panier</button>
                                        }
                                        <button onClick={()=>{deleteFromFav(f.id)}} className='favoris-remove'>Retirer</button>
                                    </div>
                                </div>

                            </div>
                        )
                    }):
                (
                    <div className="favoris-container-empty">
                        <img src={EmptyCardGIF} alt="no-favs"/>
                    </div>
                )
            }
            <Footer />

        </>
    )
}